import { AfterViewInit, Component, Input } from '@angular/core';
import { CtModelConfiguration, CtModelOperator, CtModelType } from '@ctsolution/ct-framework';
import { TaskRouteData } from '../../../_core/route-data/task.route-data';
import { DEFAULT_DATATABLE_CONFIGURATION } from '../../../_core/constants';
import { TaskListConfiguration } from './task-list.configuration';
import { Router } from '@angular/router';

@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss']
})
export class TaskListComponent implements AfterViewInit {

  configuration: CtModelConfiguration<any> | null = null;
  @Input() taskListConfiguration: TaskListConfiguration | null = null;

  constructor(private router: Router) { }

  ngAfterViewInit() {

    this.setup();

  }

  async setup() {

    const configuration = CtModelConfiguration.create()
      .setRouteData(TaskRouteData().setModelType(CtModelType.DATATABLE))
      .setCTDatatableConfiguration(DEFAULT_DATATABLE_CONFIGURATION())
      .setDisableAutoQueryFilter(false);


    if (this.taskListConfiguration?.Filters)
      this.taskListConfiguration?.Filters.forEach(filter => {
        configuration
          .filterValues
          .addConstantFilter(filter)
      });

    configuration
      .setOnCreate(() => this.onCreate())
      .setOnEdit((Event: any) => this.onEdit(Event))

    if (this.taskListConfiguration?.onlyUpdate)
      configuration
        .initialized()
        .subscribe(() => configuration?.setOperations([CtModelOperator.Update]));

    this.configuration = configuration;


  }


  async onCreate() {

    if (this.taskListConfiguration?.Action) {
      await this.taskListConfiguration.Action(null)
      if (this.taskListConfiguration.navigatePostAction == false) return;

    }

    let queryParams: any = null;

    if (this.taskListConfiguration?.param) {

      queryParams = {
        TypeExtra: this.taskListConfiguration.param.Type,
        OidExtra: this.taskListConfiguration.param.Oid
      };

    }


    this.router.navigate(['task', 'create'], {
      queryParams: queryParams
    })

  }

  async onEdit(Event: any) {

    if (this.taskListConfiguration?.Action)
      await this.taskListConfiguration.Action(null)

    let queryParams: any = null;

    if (this.taskListConfiguration?.param) {

      queryParams = {
        TypeExtra: this.taskListConfiguration.param.Type,
        OidExtra: this.taskListConfiguration.param.Oid,
        IdEvent: Event.Oid
      };

    }

    this.router.navigate(['task', 'edit', Event.Oid], {
      queryParams: queryParams
    })

  }

}

